// src/pages/FunilPermanencia.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './FunilPermanencia.css';

import { Typewriter } from "react-simple-typewriter";

const FunilPermanencia = () => {
  return (
    <main className="page-funil">

      {/* Seção 1: Introdução */}
      <section className="intro-section">
        <div className="page-content">
          <h1 className="section-title ">
            <div className="funnel-title funnel-title-1 ">Conheça o</div>
            <div className="funnel-title funnel-title-2 ">FUNIL DA PERMANÊNCIA</div>
            <div className="funnel-title funnel-title-3 ">Uma inovação da Plataforma CODI</div>
          </h1>
          <div className="funnel-image">
            <div className="funnel-image-risk-line"></div>
            <div className="funnel-image-risk-text">Risco de Evasão</div>
            <div className="funnel-image-risk-text-dynamic">
              <Typewriter
                words={["Muito Alto", "Alto", "Médio", "Baixo"]}
                loop={0}
                cursor
                cursorStyle="_"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1500}
              />
            </div>
            <div className="funnel-image-risk-text-dynamic-small">
              <Typewriter
                words={["Notas baixas", "Faltas", "Não acessou a aula", "Não entregou as atividades", "Dificuldade financeira", "Desmotivação", "Relacionamento"]}
                loop={0}
                cursor
                cursorStyle="_"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1500}
              />
            </div>
            <div className="funnel-image-walking"></div>
          </div>
          <div className="funnel-description-container">
            <div class="funnel-description-block">
              <div class="subsection1-font-text">
                <h1>Continue após a captação</h1>
                <p>Após trazer novos alunos, o desafio é mantê-los engajados e assistidos em suas necessidades.</p>
                <p>
                  Na Plataforma CODI, você acompanha a <b>Jornada do Aluno</b> pelo Funil da Permanência
                  , uma inovação tecnológica ampla e completa no combate à evasão.
                </p>
              </div>
            </div>
            <div class="funnel-description-block">
              <h1>Cuide dos seus alunos</h1>
              <ul class="li">
                <li>Gerencie a <strong>Renovação de Matrículas</strong> na virada do período letivo.</li>
                <li>Detecte alunos em <strong>Risco de Evasão</strong> com KPI's avançados.</li>
                <li>Atue na <strong>Atenção às Necessidades</strong> do discente com abordagens de acolhimento e humanização.</li>
                <li>Implemente estratégias de <strong>Retenção</strong> quando o aluno solicitar cancelamento.</li>
                <li><strong>Resgate</strong> alunos aos estudos mesmo após terem se evadido.</li>
              </ul>
            </div>
          </div>
          <Link to="/contato" className="btn btn-primary">Experimente na sua Instituição</Link>
        </div>
      </section>
      {/* /Introdução */}

      {/* Seção 2: Vídeo */}
      <section className="video-section">
        <div className="page-content">
          <div className="video-container">
            <div className="video-container-box">
              <iframe
                src="https://www.youtube.com/embed/c-7TxrxlVEY"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <div className="text-container">
            <h2 className="section-title">Gestão da Permanência</h2>
            <p className="section-text">
              A Plataforma CODI fornece indicadores que evidenciam as necessidades de cada aluno
              e permitem um atendimento personalizado.
            </p>
            <Link to="/contato" className="btn btn-primary">Agende uma Demonstração</Link>
          </div>
        </div>
      </section>
      {/* /Vídeo */}

      {/* Seção 3: Por que Funciona */}
      <section className="why-it-works-section">
        <div className="section-content">
          <div className="page-content">
            <div className="section-flex-item-left">
              <h2 className="section-title">A evasão se constrói lentamente...</h2>
              <p className="section-text">
                Notas baixas, faltas recorrentes, dificuldades financeiras e desmotivação são indícios claros de risco.
              </p>
            </div>
            <div className="section-flex-item-right">
              <p className="section-text">
                O <strong>Funil da Permanência</strong> da Plataforma CODI analisa cada aluno, automatiza alertas e
                promove processos de acolhimento, garantindo que sua equipe aja rapidamente para evitar abandonos.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* /Por que Funciona */}

      {/* Seção 4: Como Funciona */}
      <section className="how-it-works-section">
        <div className="page-content">
          <h2 className="section-title">Antecipe Sinais e Previna a Evasão</h2>
          <div className="how-it-works-container">
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Importação de Dados Diária</div>
              <div className="how-it-workds-item-content">
                A instituição faz o upload automático dos arquivos CSV para alimentar a CODI, que processa e atualiza os painéis.
              </div>
            </div>
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Sinais de Alerta</div>
              <div className="how-it-workds-item-content">
                A plataforma combina dados acadêmicos, financeiros e pedagógicos em indicadores avançados para detectar riscos de abandono.
              </div>
            </div>
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Kanban de Atendimento</div>
              <div className="how-it-workds-item-content">
                Cada sinal de alerta gera uma tarefa no <strong>BPM</strong> interno, para que equipes atuem.
              </div>
            </div>
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Acompanhamento Personalizado</div>
              <div className="how-it-workds-item-content">
                Cada caso é distribuído à equipe certa (financeiro, coordenação etc.), registrado em um CRM interno.
              </div>
            </div>
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Decisão Rápida e Eficaz</div>
              <div className="how-it-workds-item-content">
                A instituição pode oferecer sdivuções financeiras, aconselhamento pedagógico ou outras intervenções.
              </div>
            </div>
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Contato Automatizado</div>
              <div className="how-it-workds-item-content">
                É possível enviar mensagens (WhatsApp, SMS, e-mail) em lote ou individualmente.
              </div>
            </div>
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Resgate</div>
              <div className="how-it-workds-item-content">
                Se o aluno efetivamente se evadir, ainda é possível iniciar um fluxo de resgate para trazê-lo de volta.
              </div>
            </div>
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Resultados Consolidados</div>
              <div className="how-it-workds-item-content">
                Todas as ações são registradas no histórico de atendimento. Os gerentes acompanham engajamento e resultados em relatórios práticos.
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Como Funciona */}

      {/* Seção 5: Benefícios Visíveis */}
      <section className="benefits-section">
        <div className="section-content">
          <div className="page-content">
            <div className="section-flex-item-left">
              <div className="codi-diagram"></div>
            </div>
            <div className="section-flex-item-right">
              <h2 className="section-title">Afunile para transformar</h2>
              <ul className="benefits-list">
                <li><strong>Prevenção Proativa de Evasão:</strong> Atue antes que o aluno formalize o abandono.</li>
                <li><strong>Engajamento Humanizado:</strong> Integre coordenação, professores, tutores e alunos com uma comunicação que valoriza o lado humano.</li>
                <li><strong>Informações em Tempo Real:</strong> Acompanhe diariamente a situação de cada aluno com dados precisos.</li>
                <li><strong>Gestão Baseada em Evidências:</strong> Tome decisões fundamentadas em relatórios e indicadores concretos.</li>
                <li><strong>Mensageria Integrada:</strong> Dispare comunicações em múltiplos canais e registre tudo em um só lugar.</li>
                <li><strong>Ações sobre a Atividade dos Alunos:</strong> Programe alertas automáticos aos gestores sobre notas, faltas e a taxa de entrega das atividades dos alunos.</li>
                <li><strong>Flexibilidade e Integração: </strong> Compatível com TOTVS e tantos outros sistemas acadêmicos com importação de dados facilitada via CSV.</li>
              </ul>
            </div>
            <Link to="/contato" className="btn btn-primary">Entre em Contato</Link>
          </div>
        </div>
      </section>
      {/* /Benefícios */}

    </main>
  );
};

export default FunilPermanencia;
